// extracted by mini-css-extract-plugin
export default {"newsletter":"Newsletter_newsletter__BXPWm","grid":"Newsletter_grid__p5tSj","button":"Newsletter_button__BDr+n","text":"Newsletter_text__7dmPf","form":"Newsletter_form__R0eon"};